import { _ } from '../../../../shared/utils';
import { cloneDeep } from 'lodash-es';

export class VivoNotification {
  id: string;
  vivoTarget?: string;
  message: string;
  subscribers?: VivoSubscriber[];
  parents: VivoParent[];
  priority: { id: { _id: string } | null };
  actions?: { template: string | { _id: string }; }[];
  date: Date;

  constructor(data?: Partial<VivoNotification>) {
    this.id = data?.id || null;
    this.vivoTarget = data?.vivoTarget;
    this.message = data?.message || '';
    this.subscribers = cloneDeep(data?.subscribers || []);
    this.parents = cloneDeep(data?.parents || []);
    if (data?.priority?.id) {
      this.priority = { id: { _id: data.priority.id._id } };
    } else {
      this.priority = { id: null };
    }
    this.actions = cloneDeep(data?.actions || []);
    this.date = data?.date;
  }
}

export interface VivoSubscriber {
  holderID: string;
  name: string;
  type: string;
}

export interface VivoPriority {
  _id: string;
  class: string;
  default: string;
  name: string;
}

export interface POI {
  type: string;
  state: string;
  geo: VivoPosition;
}

export interface VivoParent {
  type: string;
  state: string;
}

export interface Asset extends VivoParent {
  id: string;
  name: string;
  asset?: {
    _id: string,
    name: string,
  };
}

export interface VivoPosition extends VivoParent {
  name: string;
  geo: VivoGeo;
}
export interface VivoGeo  {
  type: string;
  coordinates: number[];
}

export interface FormTemplate {
  id: string;
  name: string;
}

export interface Comment {
  contentData: string;
  contentID: string;
  contentType: string;
  type: string;
}
